<template>
    <div>
        <div class="part-member-num" :class="addClassName != null ? addClassName : 'fl'"> 
            <div class="droplayer relative">
                <!-- <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="name">
                            {{userName}}
                        </v-btn>
                    </template>
                    <div class="dropdown-list">
                        <div class="tooltip-b tl small member">
                            <ul class="">
                                <li>
                                    <div class="row1">
                                        <div class="avatar">
                                            <img v-if="userPhoto != null" :src="userPhoto" alt="" />
                                        </div>
                                        <div class="name">
                                            {{ userName }}
                                            <span v-if="userInfo != null">{{ userInfo.jobPositionName }}</span>
                                        </div>
                                        <div class="co"><span>한화생명</span></div>
                                    </div>
                                    <div class="mail ell-singleline" v-if="userInfo != null">
                                        {{ userInfo.email }}
                                    </div>
                                    <div class="tel" v-if="userInfo != null">{{ userInfo.cellPhoneNo }}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </v-menu>  -->
                <v-menu :offset-y="!isBottomLeft" :bottom="isBottomLeft" :left="isBottomLeft">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" @click="getPaperUserList()" >
                            {{defaultLanguage.indexOf('ko') != -1 ? userName : userNameEn != null ? userNameEn : userName}}{{userNameAfter}} <span class="num">{{ userCount == null ? 0 : (userCount > 999 ? '999+' : userCount) }}{{userCountAfter}}</span>
                        </v-btn>
                    </template>
                    <!-- <div class="part-member-num fl"> -->
                        <div class="dropdown-list" v-if="paperId != null">
                            <div class="top" v-html="$i18nUtil.trans('search.000.people','총 {cnt} 명',{cnt:userCount})"></div>
                            <div class="scroll">
                                <div class="members_box">
                                    <span v-for="(user, idx) in userList" :key="idx">
                                        {{ defaultLanguage.indexOf('ko') != -1 ? user.userName : user.userNameEn != null ? user.userNameEn : user.userName}}{{ (( idx+1 &lt; userList.length) ? ',&nbsp;' : '') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    <!-- </div> -->
                </v-menu>
            </div>
        </div>
        <!-- <div class="droplayer relative">
        </div> -->
    </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'userInfo',
  props: {
    userId: {
      type: String,
      required: false,
    },
    userName: {
      type: String,
      required: true,
    },
    userNameEn: {
      type: String,
    },
    userNameAfter: {
      type: String,
      required: false,
    },
    userCount: {
      type: Number,
      required: true,
    },
    userCountAfter: {
      type: String,
      required: false,
    },
    paperId: {
      type: String,
      required: false,
    },
    addClassName: {
      type: String,
      required: false,
    },
    isBottomLeft: {
      type: Boolean,
      required: false,
      default: true,
    },
    isLinkedBoard: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
        userList: [],
        // uUserCount: this.$props.userCount,
        userInfo: null,
        userPhoto: null,

        defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
    };
  },
  methods: {
    getPaperUserList() {
        let obj = this;
        let url = "/api/copaper/paperuser/getPaperUserList";
        let param = {};
        param = {
            paperId: obj.paperId,
            linkedBoardYn: obj.isLinkedBoard == true ? 'Y' : 'N',
        };
        axios
            .post(url, param)
            .then(res => {
                if (res.data.errorCode != null) {
                    return;
                }
                obj.userList = res.data.result.userList;
                obj.userCount = res.data.result.userList == null ? 0 : res.data.result.userList.length;
                const sortingUserList = obj.userList.sort((prevObj, newObj) => {
                    var prevUserName = prevObj.userName;
                    var newUserName = newObj.userName;
                    if(prevUserName < newUserName) {
                        return -1;
                    }
                    if(prevUserName > newUserName) {
                        return 1;
                    }
                    // 같을 경우
                    return 0;
                });
                obj.userList = sortingUserList;
            })
            .catch(err => {
                console.log("axios err => ", err);
            });
    },
  },
  mounted() {},
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/common/user/UserInfo.vue